import React, { Component } from "react"
import S from "./style"

class Sushi extends Component {
    state = {
        tab: "nigiri"
    }
    handleTab = (e) => {
        this.setState({
            tab: e.currentTarget.getAttribute("name")
        })
    }
    render() {
        let sushiList = []
        if(this.state.tab === "nigiri") {
            const nigiri = this.props.nigiri ? this.props.nigiri : []
            sushiList = nigiri.map((nigiri, i) => {
                const newName = nigiri.name.split("").map((letter, i, arr) => arr.indexOf("(") < i && arr.indexOf("(") >= 0 ? letter : letter.toUpperCase()).join("")
                return(
                    <S.Item key={i}>
                        <S.Name>{nigiri.name}</S.Name>
                        <S.Price>${nigiri.price}</S.Price>
                    </S.Item>
                )
            })
        } else if(this.state.tab === "handRoll") {
            const handRoll = this.props.handRoll ? this.props.handRoll : []
            sushiList = handRoll.map((handRoll, i) => {
                const newName = handRoll.name.split("").map((letter, i, arr) => arr.indexOf("(") < i && arr.indexOf("(") >= 0 ? letter : letter.toUpperCase()).join("")
                return(
                    <S.Item key={i}>
                        <S.Name>{handRoll.name}</S.Name>
                        <S.Price>${handRoll.price}</S.Price>
                    </S.Item>
                )
            })
        } else if(this.state.tab === "cutRoll") {
            const cutRoll = this.props.cutRoll ? this.props.cutRoll : []
            sushiList = cutRoll.map((cutRoll, i) => {
                const newName = cutRoll.name.split("").map((letter, i, arr) => arr.indexOf("(") < i && arr.indexOf("(") >= 0 ? letter : letter.toUpperCase()).join("")
                return(
                    <S.Item key={i}>
                        <S.Name>{cutRoll.name}</S.Name>
                        <S.Price>${cutRoll.price}</S.Price>
                    </S.Item>
                )
            })
        } else {
            const sashimi = this.props.sashimi ? this.props.sashimi : []
            sushiList = sashimi.map((sashimi, i) => {
                const newName = sashimi.name.split("").map((letter, i, arr) => arr.indexOf("(") < i && arr.indexOf("(") >= 0 ? letter : letter.toUpperCase()).join("")
                return(
                    <S.Item key={i}>
                        <S.Name>{sashimi.name}</S.Name>
                        <S.Price>${sashimi.price}</S.Price>
                    </S.Item>
                )
            })
        }
        return(
            <S.Container1>
                <S.Container2>
                    <S.List>
                        <S.TabContainer>
                            <S.Tab name="nigiri" className={this.state.tab === "nigiri" ? "selected" : ""} onClick={this.handleTab}>Nigiri</S.Tab>
                            <S.Tab name="handRoll" className={this.state.tab === "handRoll" ? "selected" : ""} onClick={this.handleTab}>Hand Roll</S.Tab>
                            <S.Tab name="cutRoll" className={this.state.tab === "cutRoll" ? "selected" : ""} onClick={this.handleTab}>Cut Roll</S.Tab>
                            <S.Tab name="sashimi" className={this.state.tab === "sashimi" ? "selected" : ""} onClick={this.handleTab}>Sashimi</S.Tab>
                        </S.TabContainer>
                        <S.Message>{this.props[this.state.tab][0].description}</S.Message>
                        {sushiList}
                    </S.List>
                </S.Container2>
            </S.Container1>
        )
    }
}

export default Sushi